import Image from "next/image";

interface ToolTile {
  name: string;
  description: string;
  imagePath?: string;
  abbrev?: string;
}

interface ToolsStackProps {
  tools: ToolTile[];
  intro?: string;
  migrationNote?: string;
}

export default function ToolsStack({ tools, intro, migrationNote }: ToolsStackProps) {
  if (!Array.isArray(tools) || tools.length === 0) {
    throw new Error("ToolsStack: `tools` array is empty or invalid.");
  }

  return (
    <div className="tools-stack">
      {intro ? <p className="tools-stack-intro">{intro}</p> : null}
      <div className="tools-grid">
        {tools.map((tool) => (
          <div key={tool.name} className="tool-tile">
            <div className="tool-tile-logo">
              {tool.imagePath ? (
                <Image
                  src={tool.imagePath}
                  alt={tool.name}
                  width={48}
                  height={48}
                  className="tool-logo-img"
                />
              ) : (
                <span className="tool-logo-abbrev">
                  {tool.abbrev ?? tool.name.slice(0, 3).toUpperCase()}
                </span>
              )}
            </div>
            <span className="tool-name">{tool.name}</span>
            <span className="tool-desc">{tool.description}</span>
          </div>
        ))}
      </div>
      {migrationNote ? (
        <p className="tools-migration-note">{migrationNote}</p>
      ) : null}
    </div>
  );
}
